import React from "react";
import { InfoIcon } from "lucide-react";
import { SectionHeading } from "../ui/SectionHeading";
import { TransformCta } from "../ui/TransformCta";
export function StorySection() {
  return <section className="bg-paper px-5 py-16 sm:py-24" data-id="element-261" data-mp="buay5jswmhnx">
      <div className="mx-auto max-w-3xl" data-id="element-262" data-mp="bwx3rdw8in3i">
        <SectionHeading title="From Disconnected Endodontic Knowledge to a Clearer Clinical Framework" data-id="element-263" data-mp="gugieewuh1vz" />
        <div className="mt-8 space-y-5 text-lg leading-relaxed text-ink/85" data-id="element-264" data-mp="kwaf6c3x5lqv">
          <p data-id="element-265" data-mp="pullicv09e4c">
            You already know about diagnosis, root canal anatomy, instrumentation, irrigation, obturation, and treatment
            outcomes.
          </p>
          <p data-id="element-266" data-mp="uneu5btlh6lp">
            But knowing these subjects individually <strong className="text-ink" data-id="element-267" data-mp="zkoggilot25b">doesn't always make it easy to connect them</strong>{" "}
            when you're reviewing a complex case.
          </p>
          <p className="font-display text-2xl font-bold text-navy" data-id="element-268" data-mp="14hoogz23kez2">That's why I created the Endo Blueprint™.</p>
          <p data-id="element-269" data-mp="1vpvu6dh720ha">
            I wanted to build a practical visual reference that helps you organize what you know, recognize what
            information is missing, and approach endodontic cases through a more structured process.
          </p>
          <p className="border-l-4 border-cyan pl-4 text-xl font-semibold text-ink" data-id="element-270" data-mp="1lsr6g97p9wyd">
            My goal is simple: help you complete a structured initial case review in 15 minutes using a repeatable
            framework.
          </p>
        </div>
        <p className="mt-8 flex gap-3 rounded-xl bg-cream p-4 text-sm leading-relaxed text-muted" data-id="element-271" data-mp="29hk204keu2sg">
          <InfoIcon className="mt-0.5 h-5 w-5 shrink-0 text-cyan" aria-hidden="true" data-id="element-272" data-mp="24qtykwvjoa0e" />
          The 15-minute target refers to organizing an initial review when the necessary information is available. It is
          not a guarantee that every case can be evaluated, diagnosed, or planned in that time.
        </p>
        <TransformCta label="I Want a Clearer Clinical Framework" data-id="element-273" data-mp="2sfwfu3m9o0ud" />
      </div>
    </section>;
}